import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import { ideasAPI } from '../services/api';
import './IdeaWidget.css';

// V70.70 — Fikrim Var: sağ alt köşede yüzen buton, tıklayınca mini sohbet kutusu.
// Öneri | Hata kategorisi seçilip mesaj gönderilir; admin Fikirler sayfasında listelenir.
// V71.13.10 — sidebar'da satır olarak durur (mini: yalnız ikon); kutu menünün yanında açılır (body'ye portal)
export default function IdeaWidget({ mini = false }) {
  const [open, setOpen] = useState(false);
  const [kategori, setKategori] = useState('oneri');
  const [mesaj, setMesaj] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const { pathname } = useLocation();
  const boxRef = useRef(null);
  const popRef = useRef(null);

  // Dışarı tıklayınca / ESC ile kapan
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => { if (!boxRef.current?.contains(e.target) && !popRef.current?.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape' && !document.querySelector('.custom-dialog-overlay')) setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [open]);

  // V71 — kutu açıkken Hızlı Araçlar FAB'ı gizlenir (aynı sağ kenarda üst üste binmesin)
  useEffect(() => {
    document.documentElement.toggleAttribute('data-idea-open', open);
    return () => document.documentElement.removeAttribute('data-idea-open');
  }, [open]);

  const handleSend = async () => {
    if (!mesaj.trim() || sending) return;
    setSending(true);
    try {
      await ideasAPI.send({ kategori, mesaj: mesaj.trim(), sayfa: pathname });
      setSent(true);
      setMesaj('');
      setTimeout(() => { setSent(false); setOpen(false); }, 2200);
    } catch (e) {
      alert(e.response?.data?.error || 'Gönderilemedi, tekrar deneyin.');
    } finally {
      setSending(false);
    }
  };

  const box = open && createPortal(
        <div className="idea-box idea-box-pop" role="dialog" aria-label="Fikrim Var" ref={popRef}>
          <div className="idea-box-head">
            <span className="idea-box-ic">🚀</span>
            <div>
              <div className="idea-box-title">Fikrim Var</div>
              <div className="idea-box-sub">Önerin ya da gördüğün hata — direkt yönetime ulaşır</div>
            </div>
            <button className="idea-box-close" onClick={() => setOpen(false)} title="Kapat" aria-label="Kapat">×</button>
          </div>
          {sent ? (
            <div className="idea-box-done">🎉 Teşekkürler! İletildi.</div>
          ) : (
            <>
              <div className="idea-cats">
                <button className={`idea-cat oneri${kategori === 'oneri' ? ' on' : ''}`} onClick={() => setKategori('oneri')}>💡 Öneri</button>
                <button className={`idea-cat hata${kategori === 'hata' ? ' on' : ''}`} onClick={() => setKategori('hata')}>🐞 Hata</button>
              </div>
              <textarea
                className="idea-input"
                rows={4}
                autoFocus
                placeholder={kategori === 'hata' ? 'Hatayı kısaca anlat: hangi sayfada, ne yaptın, ne oldu?' : 'Aklındaki öneriyi yaz…'}
                value={mesaj}
                maxLength={2000}
                onChange={e => setMesaj(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) handleSend(); }}
              />
              <div className="idea-box-foot">
                <span className="idea-hint">Ctrl+Enter ile gönder</span>
                <button className="idea-send" disabled={!mesaj.trim() || sending} onClick={handleSend}>
                  {sending ? 'Gönderiliyor…' : 'Gönder'}
                </button>
              </div>
            </>
          )}
        </div>
    , document.body);

  return (
    <div className={`idea-sb${mini ? ' mini' : ''}${open ? ' open' : ''}`} ref={boxRef}>
      <button type="button" className="idea-sb-btn" onClick={() => setOpen(v => !v)} title="Fikrim Var — öneri ya da hata bildir" aria-label="Fikrim Var" aria-expanded={open}>
        <span className="idea-sb-ic">🚀</span>
        {!mini && (
          <span className="idea-sb-text">
            <span className="idea-sb-title">Fikrim Var</span>
            <span className="idea-sb-sub">Öneri · Hata bildir</span>
          </span>
        )}
      </button>
      {box}
    </div>
  );
}
